import axios from 'axios'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import CreateAttachment from './dto/CreateAttachment'
import GetAttachment from './dto/GetAttachment'
import UpdateAttachment from './dto/UpdateAttachment'
import GetAllWorkExperience from './dto/GetAllWorkExperience'
import { PagedWorkExperienceResultRequestDto } from './dto/PagedWorkExperienceResultRequestDto'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/WorkExperience/Create`
export const URL_DELETE = `${API_URL}/WorkExperience/Delete`
export const URL_GET = `${API_URL}/WorkExperience/Get`
export const URL_GET_ALL = `${API_URL}/WorkExperience/GetPagedAll`
export const URL_UPDATE = `${API_URL}/WorkExperience/Update`

export function onCreateWorkExperience(createAttachment: CreateAttachment): Promise<boolean> {
  return axios.post(URL_CREATE, createAttachment)
}

export function onDeleteWorkExperience(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetWorkExperience(entityDto: EntityDto): Promise<GetAttachment> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllWorkExperiences(
  pagedFilterAndSortedRequest: PagedWorkExperienceResultRequestDto
): Promise<PagedResultDto<GetAllWorkExperience>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateWorkExperience(updateAttachmentInput: UpdateAttachment): Promise<boolean> {
  return axios.put(URL_UPDATE, updateAttachmentInput)
}
